<template>
    <div>
        <a class="js-go-to u-go-to" href="#"
           data-position='{"bottom": 15, "right": 15 }'
           data-type="fixed"
           data-offset-top="400"
           data-compensation="#header"
           data-show-effect="slideInUp"
           data-hide-effect="slideOutDown">
            <span class="fas fa-arrow-up u-go-to__inner"></span>
        </a>
        <script type="application/javascript" v-bind:src="hsGotoSrc"></script>
        <script type="application/javascript" v-bind:src="hsGotoPluginInit"></script>
    </div>
</template>

<script>
    import {JS_FILES} from "../settings/scripts";

    export default {
        name: "GoToTop",
        data() {
            return {
                hsGotoSrc: JS_FILES.hs.goto.script,
                hsGotoPluginInit: JS_FILES.hs.goto.pluginInit
            }
        }
    }
</script>

<style scoped>

</style>